import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';

export class TechRadarZF implements TechRadarApi {
  async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
    // if needed id prop can be used to fetch the correct data

    const data = require('../techradar.json');

    // For example, this converts the timeline dates into date object
    return {
      ...data,
      entries: data.entries.map((entry: any) => ({
        ...entry,
        timeline: entry.timeline.map(
          (timeline: { date: string | number | Date }) => ({
            ...timeline,
            date: new Date(timeline.date),
          }),
        ),
      })),
    };
  }
}
